
import { List, Image, Radio, Space } from 'antd';
import { useEffect, useState } from 'react';
import { BlobDto } from '../../Repository/eventbookyapi';
import { TextService } from '../../Services/TextService';

export const getVersionedImageUri = (uri: string, lastModified?: Date | null) => {
    return lastModified ? uri + "?v=" + new Date(lastModified).getTime() : uri;
}

enum ImageCategory {
    PictureArchive = 0,
    StockPhotos = 1,
}

const ImageSelect = (props: any) => {
    const GetText = TextService.GetText;

    // Event banner picker only (not isPublicImage): the company's picture archive first, then
    // OneFront's stock photos.
    const [category, setCategory] = useState(ImageCategory.PictureArchive);
    const [images, setImages] = useState<BlobDto[]>([]);

    const getDownloadUrl = (dto: BlobDto) => {
        // downloadFile (not downloadImage) - this authenticated, company-scoped picker lists the
        // admin's own uploaded images, which downloadImage no longer serves (it only serves a
        // company's current logo or an event's current banner, to stay safe for anonymous callers).
        return props.isPublicImage ? dto.uri! : process.env.REACT_APP_API_URL + '/Image/downloadFile?bloburl=' + dto.relativeUri;
    }

    // A public image re-uploaded under the same file name keeps its URL, so without a version the
    // browser (and email clients that cache by URL) keep showing the previous image. Used for the
    // URL handed to onImageSelect too, so the version ends up in the saved email/template.
    const getVersionedUrl = (dto: BlobDto) => {
        const url = getDownloadUrl(dto);
        return props.isPublicImage ? getVersionedImageUri(url, dto.lastModified) : url;
    }

    // Optional: the company's picture archive (Bildarkiv), offered as its own tab in the event banner
    // picker. These live in the public container, so they are shown by their direct URI.
    const archiveImages: BlobDto[] = props.archiveImages ?? [];
    const isArchiveImage = (item: BlobDto) => archiveImages.indexOf(item) !== -1;

    const getItemUrl = (item: BlobDto) => {
        return isArchiveImage(item) ? getVersionedImageUri(item.uri!, item.lastModified) : getVersionedUrl(item);
    }

    useEffect(() => {
        if (props.isPublicImage) {
            setImages(props.images);
        }
        else if (category == ImageCategory.StockPhotos) {
            setImages(props.images.filter((item: BlobDto) => item.isPublicImage));
        }
        else {
            setImages(archiveImages);
        }
    }, [category, props]);
    return (
        <>
            {props.isPublicImage ? "" : <Radio.Group value={category} onChange={(e) => { setCategory(e.target.value) }}>
                <Space direction="horizontal" onClick={() => { }}>
                    <Radio value={ImageCategory.PictureArchive}>{GetText("ImageSelect_PictureArchive")}</Radio>
                    <Radio value={ImageCategory.StockPhotos}>{GetText("ImageSelect_PublicPhotos")}</Radio>
                </Space>

            </Radio.Group>}
            <List
                grid={{ gutter: 18, column: 4 }}
                dataSource={images}
                renderItem={(item: BlobDto) => (

                    <List.Item onClick={(e) => { props.onImageSelect(getItemUrl(item), item) }}>
                        <Image className={props.selectedImage && props.selectedImage.indexOf(item.relativeUri) != -1 ? "image-selected" : ""} width={200} height={130} preview={false} style={{ padding: "10px" }} src={getItemUrl(item)} ></Image>
                    </List.Item >
                )}
            />
        </>)
};

export default ImageSelect;